import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth'; // Ensure this is imported
import { getFirestore } from 'firebase/firestore'; // Firestore added here
import { getStorage } from 'firebase/storage';


const firebaseConfig = {
  apiKey: "AIzaSyCblfwGtzmiV-F9T2ETkY_jO7W7IXT_QDY", // Your API key
  authDomain: "hirefly-d981e.firebaseapp.com", 
  projectId: "hirefly-d981e",
  storageBucket: "hirefly-d981e.appspot.com",
  messagingSenderId: "81447526638",
  appId: "1:81447526638:web:c34ad2cc101cdb003993ff",
  measurementId: "G-6XXLCEGWMP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app); // Optional, if you're using Firebase Analytics
const db = getFirestore(app); // Firestore exported here
const auth = getAuth(app); // Firebase Auth initialization
const storage = getStorage(app);

export { db, auth, storage }; // Export both Firestore (db) and Firebase Auth (auth)
